<template>
  <section class="discover">
    <LandingPage class="landingPage"/>
    <DiscoverPage />
    <FooterPage class="footerPage"/>
    <Footer />
  </section>
</template>

<script>
import LandingPage from '@/components/hgDiscover/LandingPage';
import DiscoverPage from '@/components/hgDiscover/DiscoverPage';
import FooterPage from '@/components/hgDiscover/FooterPage';
import Footer from '@/components/Footer';

export default {
  name: 'Discover',
  components: {
    LandingPage,
    DiscoverPage,
    FooterPage,
    Footer
  }
}
</script>

<style scoped>
.discover {
  background: #1e1e1e;
}
@media (max-width: 900px) {
  .landingPage {
    display: none;
  }
  .footerPage {
    display: none;
  }
}
</style>
